import js from  '../img/blogs/js.png';
import a2z from  '../img/blogs/a2z.png';
import dsa from  '../img/blogs/dsa.jpg';



const blogs = [
    {
        id: 1,
        title: 'JAVASCRIPT-MCQ',
        date: '01',
        month: 'April',
        image: js,
        link: 'https://github.com/prabhukumarsaw/JAVASCRIPT-MCQ'
    },
    {
        id: 2,
        title: 'Challange-500-C-Programming-Code',
        date: '01',
        month: 'April',
        image: dsa,
        link: 'https://github.com/prabhukumarsaw/Challange-500-C-Programming-Code'
    },
    {
        id: 3,
        title: 'Amazon-SDE-code-Cracker',
        date: '01',
        month: 'April',
        image: a2z,
        link: "https://github.com/prabhukumarsaw/Amazon-SDE-code-Cracker"
    }
]

export default blogs;